import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import DataContext from '../components/DataContext/DataContext';
import { PPSI } from '@ikea-food-ux/ppsi';
import stichPpsi from '../util/ui2pStichPPSI';
import RedirectToMenu from '../components/util/Redirect';

const PPSIView = () => {
  const { id } = useParams();
  const {
    isFetching,
    ppsis,
    ppis,
    labels,
    timeUnits,
    temperatureUnits,
    firstStorage,
    productionOptions,
    utensils,
    language,
    unitSystem,
    shelfLifeTimeUnits
  } = useContext(DataContext);
  let ppsi;

  if(!isFetching){
    ppsi =  ppsis && ppsis.find(ppsi => ppsi.id === id);
  }
  if (!isFetching && !ppsi) {

    console.warn(`Ops! No PPSI available with given id :(   (${id})`);
    return <RedirectToMenu />;
  }

  const checkPpiExcluded = ppsi && ppsi.ppiDetails.filter(i=> i.ppiNotRequired === false);
  const finalPpsi = {...ppsi, ppiDetails: checkPpiExcluded}
  let stitchedPpsi = stichPpsi(finalPpsi, ppis);
  stitchedPpsi.ppiDetails = stitchedPpsi.ppiDetails.map(itm=>({
    ...itm,
    ppi: {
      ...itm.ppi,
      isNew: itm.ppi.ppiTag === 'new',
      isUpdated: itm.ppi.ppiTag === 'updated'
    } 
  }))
  
  return (
    <PPSI
      ppsi={
        {...stitchedPpsi, isNew: stitchedPpsi.ppsiTag === 'new',
         isUpdated: stitchedPpsi.ppsiTag === 'updated'}}
      labels={labels}
      timeUnits={timeUnits}
      temperatureUnits={temperatureUnits}
      stockHierarchy={firstStorage}
      productionOptions={productionOptions}
      utensils={utensils}
      language={language}
      scrollOffset={64}
      unitSystem={unitSystem}
      shelfLifeTimeUnits={shelfLifeTimeUnits}
      piaArticleNumber={stitchedPpsi && stitchedPpsi.piaArticleNumber}
    />
  );
};

export default PPSIView;
